import { configureStore } from '@reduxjs/toolkit'
import sdGlobalSearchReducer from '../containers/searchLandingSlice'
import sdGlobalProductReducer from '../containers/supportSearch/supportSearchSlice';
import sdGlobalNewsRoomReducer from '../containers/newsroomSlice/newsRoomSlice';
// import pressReleaseSlice from '../containers/pressReleaseSlice/pressReleaseSlice';
import eventReducer from '../containers/eventSlice/eventSlice'
import categorySelectionReducer from '../containers/categorySlice/categorySlice';
import resourceLibraryReducer from '../containers/resourceLibrarySice/resourceLibrarySlice';
import commonReducer from '../containers/common/commonSlice'

const store = configureStore({
  reducer: {
    searchLanding: sdGlobalSearchReducer,
    supportSearch: sdGlobalProductReducer,
    eventsDetails: eventReducer,
    newsRoomDetails: sdGlobalNewsRoomReducer,
    categorySelection: categorySelectionReducer,
    resourceLibrary: resourceLibraryReducer,
    common:commonReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable the serializable check
    }),
})

export default store